<app-sales-additional-information-general (nextStepEvent)="onNextStep()" *ngIf="categoryCode!=Category.kredicash"/>
<app-sales-aditional-information-kedicash (nextStepEvent)="onNextStep()" *ngIf="categoryCode==Category.kredicash"/>


